// extracted by mini-css-extract-plugin
export default {"main":"EmotionalQuotient_main__BTRtq"};